import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Impressum = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => {
    document.title = language === 'de' ? 'SourSweet.de/Impressum' : 'SourSweet.de/Imprint';
  }, [language]);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-emerald-800 pt-24 pb-16 px-4 md:px-8 print:!bg-white print:!pt-0 print:!pb-0 print:!px-0 print:!min-h-0" data-testid="impressum-page">
      <div className="max-w-4xl mx-auto">
        {/* Content Card */}
        <div className="bg-lime-50 rounded-2xl shadow-xl p-8 md:p-12 print:!shadow-none print:!p-0 print:!rounded-none print:!bg-white">
          {/* Header */}
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-emerald-800 mb-8 text-center print:text-black print:!mb-6">
            {language === 'de' ? 'Impressum' : 'Imprint'}
          </h1>

          {/* Content */}
          <div className="prose prose-emerald max-w-none text-emerald-800 print:text-black">
            {/* Anbieter / Provider */}
            <section className="mb-8 print:!mb-5">
              <h2 className="font-heading text-xl font-bold text-emerald-700 mb-4 print:text-black print:!mb-2">
                {language === 'de' ? 'Anbieter' : 'Provider'}
              </h2>
              <p className="text-emerald-700 font-medium leading-relaxed print:text-black">
                SourSweet<br />
                {language === 'de' ? 'Inhaber' : 'Owner'}: Cem Koptas<br />
                Bärensteinstraße 2<br />
                12685 Berlin<br />
                {language === 'de' ? 'Deutschland' : 'Germany'}
              </p>
            </section>

            {/* Kontakt / Contact */}
            <section className="mb-8 print:!mb-5">
              <h2 className="font-heading text-xl font-bold text-emerald-700 mb-4 print:text-black print:!mb-2">
                {language === 'de' ? 'Kontakt' : 'Contact'}
              </h2>
              <p className="text-emerald-700 font-medium leading-relaxed print:text-black">
                E-Mail: <a href="mailto:info@soursweet.de" className="text-lime-600 hover:underline print:text-black">info@soursweet.de</a><br />
                {language === 'de' ? 'Telefon' : 'Phone'}: <a href="tel:+4901622755781" className="text-lime-600 hover:underline print:text-black">+49 0162 2755781</a>
              </p>
            </section>

            {/* Gewerbeanmeldung / Business Registration */}
            <section className="mb-8 print:!mb-5">
              <h2 className="font-heading text-xl font-bold text-emerald-700 mb-4 print:text-black print:!mb-2">
                {language === 'de' ? 'Gewerbeanmeldung' : 'Business Registration'}
              </h2>
              <p className="text-emerald-700 font-medium leading-relaxed print:text-black">
                {language === 'de' 
                  ? 'Gewerbeanmeldung nach § 14 GewO'
                  : 'Business registration pursuant to § 14 GewO'}
              </p>
            </section>

            {/* Inhaltlich Verantwortlich / Person Responsible for Content */}
            <section className="mb-8 print:!mb-5">
              <h2 className="font-heading text-xl font-bold text-emerald-700 mb-4 print:text-black print:!mb-2">
                {language === 'de' ? 'Inhaltlich Verantwortlich' : 'Person Responsible for Content'}
              </h2>
              <p className="text-emerald-700 font-medium leading-relaxed print:text-black">
                {language === 'de' 
                  ? <>Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV:<br />Cem Koptas</>
                  : 'Cem Koptas'}
              </p>
            </section>

            {/* Online-Streitbeilegung / Online Dispute Resolution */}
            <section className="print:!mb-0">
              <h2 className="font-heading text-xl font-bold text-emerald-700 mb-4 print:text-black print:!mb-2">
                {language === 'de' ? 'Online-Streitbeilegung' : 'Online Dispute Resolution'}
              </h2>
              <p className="text-emerald-700 font-medium leading-relaxed print:text-black">
                {language === 'de' 
                  ? <>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br /></>
                  : ''}
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:underline print:text-black break-all">
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-emerald-700 font-medium leading-relaxed mt-4 print:text-black print:!mt-2 print:!mb-0">
                {language === 'de' 
                  ? 'Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
                  : 'We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.'}
              </p>
            </section>
          </div>

          {/* Buttons - Hidden on Print */}
          <div className="flex justify-center mt-10 print:!hidden print:!m-0 print:!p-0 print:!h-0">
            <button
              onClick={handleClose}
              className="flex items-center justify-center gap-2 bg-emerald-700 text-white hover:bg-emerald-600 hover:shadow-[0_0_25px_rgba(52,211,153,0.6)] transition-all duration-300 rounded-lg px-8 py-3 font-bold"
              data-testid="close-button"
            >
              <X size={20} />
              {language === 'de' ? 'Schließen' : 'Close'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
